import { render, staticRenderFns } from "./SelectedTag.vue?vue&type=template&id=315a8eb9&scoped=true&"
import script from "./SelectedTag.vue?vue&type=script&lang=js&"
export * from "./SelectedTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a8eb9",
  null
  
)

export default component.exports